import { BrowserInfo } from '../helpers/browser_info';
export class BrowserService {
    browser;
    $window;
    log;
    supportsExtendedLocaleCompareCache;
    static $inject = ['$window', 'LogService'];
    constructor($window, logService) {
        this.$window = $window;
        this.log = logService.getLogger('Browser-S');
    }
    getBrowser() {
        if (this.browser === undefined) {
            const browser = {
                chrome: false,
                chromeIos: false,
                firefox: false,
                firefoxIos: false,
                ie: false,
                edge: false,
                opera: false,
                safari: false,
            };
            const uagent = this.$window.navigator.userAgent.toLowerCase();
            browser.chrome = /webkit/.test(uagent) && /chrome/.test(uagent) && !/edg/.test(uagent);
            browser.chromeIos = /mozilla/.test(uagent) && /crios/.test(uagent);
            browser.firefox = /mozilla/.test(uagent) && /firefox/.test(uagent);
            browser.firefoxIos = /mozilla/.test(uagent) && /fxios/.test(uagent);
            browser.ie = (/msie/.test(uagent) || /trident/.test(uagent)) && !/edge/.test(uagent);
            browser.edge = /edg/.test(uagent);
            browser.safari = /safari/.test(uagent) && /applewebkit/.test(uagent)
                && !/chrome/.test(uagent) && !/fxios/.test(uagent) && !/crios/.test(uagent);
            browser.opera = /mozilla/.test(uagent) && /applewebkit/.test(uagent)
                && /chrome/.test(uagent) && /safari/.test(uagent) && /opr/.test(uagent);
            if (browser.opera && browser.chrome) {
                browser.chrome = false;
            }
            let version = null;
            for (const x in browser) {
                if (browser[x]) {
                    let b;
                    if (x === 'ie') {
                        b = 'msie';
                    }
                    else if (x === 'edge') {
                        b = 'edge?';
                    }
                    else if (x === 'opera') {
                        b = 'opr';
                    }
                    else if (x === 'firefoxIos') {
                        b = 'fxios';
                    }
                    else if (x === 'chromeIos') {
                        b = 'crios';
                    }
                    else if (x === 'safari') {
                        b = 'version';
                    }
                    else {
                        b = x;
                    }
                    let match = uagent.match(new RegExp('(' + b + ')( |\/)([0-9]+)'));
                    let versionString;
                    if (match) {
                        versionString = match[3];
                    }
                    else {
                        match = uagent.match(new RegExp('rv:([0-9]+)'));
                        versionString = match ? match[1] : '';
                    }
                    const versionInt = parseInt(versionString, 10);
                    version = isNaN(versionInt) ? undefined : versionInt;
                    break;
                }
            }
            if (browser.chrome) {
                this.browser = new BrowserInfo(uagent, "chrome", version);
            }
            if (browser.chromeIos) {
                this.browser = new BrowserInfo(uagent, "chromeIos", version, true);
            }
            if (browser.firefox) {
                this.browser = new BrowserInfo(uagent, "firefox", version);
            }
            if (browser.firefoxIos) {
                this.browser = new BrowserInfo(uagent, "firefoxIos", version, true);
            }
            if (browser.ie) {
                this.browser = new BrowserInfo(uagent, "ie", version);
            }
            if (browser.edge) {
                this.browser = new BrowserInfo(uagent, "edge", version);
            }
            if (browser.safari) {
                const mobile = /mobile/.test(uagent);
                this.browser = new BrowserInfo(uagent, "safari", version, mobile);
            }
            if (browser.opera) {
                this.browser = new BrowserInfo(uagent, "opera", version);
            }
            if (this.browser === undefined) {
                this.log.warn(`Browser could not be recognized. User agent: ${uagent}`);
                this.browser = new BrowserInfo(uagent, null, null);
            }
        }
        return this.browser;
    }
    supportsWebrtcTask() {
        if (this.browser === undefined) {
            this.getBrowser();
        }
        return this.browser.supportsWebrtcTask();
    }
    supportsExtendedLocaleCompare() {
        if (this.supportsExtendedLocaleCompareCache !== undefined) {
            return this.supportsExtendedLocaleCompareCache;
        }
        function getSupport() {
            try {
                'foo'.localeCompare('bar', 'i');
            }
            catch (e) {
                return e.name === 'RangeError';
            }
            return false;
        }
        const support = getSupport();
        this.supportsExtendedLocaleCompareCache = support;
        this.log.debug(`Browser ${support ? 'supports' : 'does not support'} extended locale compare options`);
        return support;
    }
}
